import React, { useCallback, useContext, useState, useEffect, useMemo, useRef } from 'react';
import { svgSprite, Img, zendoStorage, A } from '../../../../hybrid/wrappers';
import UserContext, { StoreContext } from '../../../../common/utils/getContext';
import { navigateV2 } from '../../../../common/utils/router';
import { useUnscrollableBody, useWindowDimensions } from '../../../../common/utils/windowDimensions';
// import T from '../../../../common/components/T';
// import LangSwitcherMob from '../../../../widgets/langSwitcher/LangSwitcherMobile/LangSwitcherMobile';
import SingleMenu from '../../../../widgets/menu/single/SingleMenu/SingleMenu';
// import uikit from '../../../../project/uikit/uikit.module.scss';
// import MobMenu from '../../../../hybrid/library/MobMenu/MobMenu';
// const project = require('../../../../scripts/configs/project');
import logo from '../../../../public/logo.svg';
// import topBanner from '../../../../public/src/header-top.jpg';
// import topBannerMob from '../../../../public/src/header-logo_mob.jpg';
import logoshort from '../../../../public/logo-short.svg';
import defaultCss from './single-header.module.scss';
import classNames from 'classnames';
import { UseQuickNotifications } from '../../../../common/utils/UseQuickNotifications';
import NotificationsQuick from '../../../../widgets/notifications/NotificationsQuick/NotificationsQuick';
import { API_SERVER_URL, checkBrowser } from '../../../../common/utils/utils';
import axios from 'axios';
import HeaderButtons from './components/HeaderButtons/HeaderButtons';
import MenuOfficeMobile from '../../../../widgets/menu/single/mobile/MenuOffice/MenuOffice';

const SingleHeader = ({ beforeHeaderRef, compStyles }) => {
    const [expanded, setExpanded] = useState(false);

    const headerRef = useRef();

    const { setUserToken, userToken } = useContext(UserContext);
    // const { profileData } = useContext(UserProfileContext) || {};

    // перевірка чи це сторінка магазину
    const isStorePage = useContext(StoreContext);

    const logout = () => {
        axios({
            method: 'POST',
            url: `${API_SERVER_URL}/api/v1/logout`,
            headers: {
                ...(userToken ? { Authorization: `Bearer ${userToken}` } : {}),
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json;charset=UTF-8'
            }
        }).finally(() => {
            setUserToken(false);
            zendoStorage.remove('cart_id');
            zendoStorage.remove('display_country');
            document.location.reload();
        });
    };

    const toggleMenu = useCallback(
        (data) => {
            setExpanded(data === false || data === true ? data : !expanded);
        },
        [setExpanded, expanded]
    );

    const windowDimensions = useWindowDimensions();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (!isMobile) {
            setExpanded(false);
        }
    }, [isMobile]);

    useEffect(() => {
        if (windowDimensions < 992) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [windowDimensions]);

    useUnscrollableBody(expanded, 'Single');
    // const [showMenuUser, setShowMenuUser] = useState(false);
    // const [showMenuUserInModal, setShowMenuUserInModal] = useState(false);

    // const currentYear = new Date().getFullYear();

    const { quickNotifications } = UseQuickNotifications();

    const headLogo = useMemo(() => {
        switch (true) {
            case windowDimensions > 1300: {
                return logo;
            }
            case windowDimensions > 992: {
                return logoshort;
            }
            case windowDimensions > 768: {
                return logo;
            }
            default:
                return logoshort;
        }
    }, [windowDimensions]);

    const func = () => {
        if (headerRef?.current) {
            const scrollY = window.scrollY;
            const beforeHeaderBlockHeight = checkBrowser(beforeHeaderRef?.current?.getBoundingClientRect().height);

            const topPosition = beforeHeaderBlockHeight - scrollY < 0 ? 0 : beforeHeaderBlockHeight - scrollY;
            headerRef.current.style.top = `${topPosition}px`;
        }
    };
    const width = useWindowDimensions();
    useEffect(() => {
        if (!beforeHeaderRef?.current) return;
        const listener = () => {
            func();
        };
        func();
        document.addEventListener('scroll', listener);
        return () => {
            document.removeEventListener('scroll', listener);
        };
    }, [beforeHeaderRef?.current, width]);

    const [isInputOpened, setIsInputOpened] = useState(false);

    useEffect(() => {
        if (!headerRef.current) return;

        const updateHeaderHeight = () => {
            const height = headerRef.current?.getBoundingClientRect().height || 0;
            document.documentElement.style.setProperty('--single-header-height', `${height}px`);
        };

        updateHeaderHeight();

        const observer = new ResizeObserver(updateHeaderHeight);
        observer.observe(headerRef.current);

        window.addEventListener('resize', updateHeaderHeight);

        return () => {
            observer.disconnect();
            window.removeEventListener('resize', updateHeaderHeight);
            document.documentElement.style.removeProperty('--single-header-height');
        };
    }, [userToken, isMobile, windowDimensions]);

    return (
        <>
            <div>
                {/* <MobMenu
                    expanded={expanded}
                    removeMenu={() => toggleMenu()}
                    compStyles={{ MenuStyles: classNames(defaultCss.WebMenu, !expanded && defaultCss.WebMenuHidden) }}
                > */}
                {expanded ? <MenuOfficeMobile mainMenu={expanded} toggleMenu={toggleMenu} /> : null}
                {/* <div onClick={() => toggleMenu()} className={defaultCss.menuTitle}>
                        <div className={defaultCss.menuCloseBtn}>
                            {svgSprite('arrow-left', {
                                className: defaultCss.menuCloseBtnIcon,
                                width: '15',
                                height: '11'
                            })}
                        </div>
                        <div className={defaultCss.menuTitleLogo}>
                            <A href={`/`} style={{ display: 'block' }}>
                                {svgSprite('company-logo', {
                                    className: defaultCss.menuTitleLogoIcon,
                                    width: '166',
                                    height: '24px',
                                    fill: 'var(--whiteColor)',
                                    logofill: 'var(--whiteColor)'
                                })}
                            </A>
                        </div>
                    </div>
                    {!profileData && (
                        <div className={defaultCss.menuActionTop}>
                            <div className={defaultCss.menuActionItem}>
                                <A
                                    href={{
                                        as: '/authentication/login',
                                        pathname: '/authentication/[type]',
                                        query: { type: 'login' }
                                    }}
                                    className={classNames(
                                        defaultCss.buttonTransparentOutline,
                                        defaultCss.enterButton,
                                        defaultCss.menuActionBtn
                                    )}
                                >
                                    <T textName='menuActionItemLogin' defaultStr='Войти' page='/' />
                                </A>
                            </div>
                            <div className={defaultCss.menuActionItem}>
                                <A
                                    href={{
                                        as: '/authentication/register',
                                        pathname: '/authentication/[type]',
                                        query: { type: 'register' }
                                    }}
                                    className={classNames(
                                        defaultCss.buttonWhite,
                                        defaultCss.enterButton,
                                        defaultCss.menuActionBtn
                                    )}
                                >
                                    <T textName='menuActionItemRegister' defaultStr='Регистрация' page='/' />
                                </A>
                            </div>
                        </div>
                    )}
                    <div className={defaultCss.menuScroll}>
                        <div className={defaultCss.menuWrapper}>
                            <div className={classNames(defaultCss.wrapLinksMenu, defaultCss.flexColumn, defaultCss.dFlex)}>
                                {profileData && (
                                    <div
                                        style={{
                                            justifyContent: 'flex-end',
                                            padding: '20px 28px 12px 20px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                border: 'none'
                                            }}
                                            className={classNames(defaultCss?.wrapperItem)}
                                            onClick={() => {
                                                setShowMenuUserInModal((pre) => !pre);
                                            }}
                                        >
                                            <div style={{ display: 'flex' }}>
                                                <div
                                                    style={{ margin: '0 12px 0 0' }}
                                                    className={classNames(defaultCss.singleImage)}
                                                >
                                                    {!profileData?.image?.links?.preview ? (
                                                        svgSprite('plug-user-image', {
                                                            width: '24px',
                                                            height: '24px'
                                                        })
                                                    ) : (
                                                        <Img
                                                            className={defaultCss.singleImageItem}
                                                            src={profileData?.image?.links?.preview}
                                                        />
                                                    )}
                                                </div>
                                                <div
                                                    style={{
                                                        marginRight: '12px',
                                                        lineHeight: '1.06',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    {!profileData.last_name && !profileData.first_name ? (
                                                        <div>{profileData.username}</div>
                                                    ) : (
                                                        <div>
                                                            {profileData.last_name} {profileData.first_name}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                {svgSprite('angle-left', {
                                                    style: {
                                                        width: 10,
                                                        height: 10,
                                                        fill: 'var(--greySuperDarkColor)'
                                                    }
                                                })}
                                            </div>
                                        </div>
                                        {showMenuUserInModal && (
                                            <div>
                                                <div
                                                    style={{ borderRadius: '4px' }}
                                                    className={classNames(defaultCss.modalLangListDesktop)}
                                                >
                                                    <div
                                                        style={{
                                                            padding: '12px 0 12px 48px'
                                                        }}
                                                        className={classNames(
                                                            defaultCss.modalLangListItemDesktop,
                                                            defaultCss.modalLangListItemFirst
                                                        )}
                                                        onClick={() => {
                                                            navigateV2('/office');
                                                        }}
                                                    >
                                                        <p className={defaultCss.menuLangSwitcherInfoDesktop}>
                                                            <T
                                                                textName='menuLangSwitcherInfoDesktop'
                                                                defaultStr='Личный кабинет'
                                                                page='/'
                                                            />
                                                        </p>
                                                    </div>
                                                    <div
                                                        style={{
                                                            padding: '0 0 12px 48px'
                                                        }}
                                                        className={classNames(
                                                            defaultCss.modalLangListItemDesktop,
                                                            defaultCss.modalLangListItemFirst
                                                        )}
                                                        onClick={async () => logout()}
                                                    >
                                                        <p className={defaultCss.menuLangSwitcherInfoDesktop}>
                                                            <T textName='logoutTitle' defaultStr='Выйти' page='all' />
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <SingleMenu componentCss={defaultCss} isMobile={isMobile} />
                            </div>
                        </div>
                    </div>
                    {windowDimensions <= 992 && <LangSwitcherMob />}
                    {isMobile && (
                        <div className={defaultCss.appWrapperButtons}>
                            <div
                                style={{
                                    borderWidth: '1px ',
                                    borderStyle: 'solid',
                                    borderColor: 'var(--darkExtraTransparentColor)'
                                }}
                                className={classNames(defaultCss.btnApp, uikit.mr1, uikit.mb2)}
                                onClick={() => {
                                    window.open('https://apps.apple.com/ua/app/flawless-core/id1644844621?l=uk', '_blank');
                                }}
                            >
                                <div className={classNames(uikit.flexRow, uikit.alignItemsCenter)}>
                                    {svgSprite('app-store-colored', {
                                        className: classNames(defaultCss.buttonAppSvg, uikit.mr2),
                                        width: '25',
                                        height: '31'
                                    })}
                                    <div className={uikit.flexColumn}>
                                        <p className={defaultCss.appButtonTextSm}>
                                            <T textName='appButtonText' defaultStr='Загрузите в' page='/' />
                                        </p>
                                        <p>App Store</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    borderWidth: '1px ',
                                    borderStyle: 'solid',
                                    borderColor: 'var(--darkExtraTransparentColor)'
                                }}
                                className={classNames(defaultCss.btnApp, uikit.ml1, uikit.mb2)}
                                onClick={() => {
                                    window.open(
                                        'https://play.google.com/store/apps/details?id=com.flawlesscore&hl=ru&gl=US',
                                        '_blank'
                                    );
                                }}
                            >
                                <div className={classNames(uikit.flexRow, uikit.alignItemsCenter)}>
                                    {svgSprite(
                                        'google-play-colored',
                                        {
                                            className: classNames(defaultCss.buttonAppSvg, uikit.mr2),
                                            width: '28',
                                            height: '31'
                                        },
                                        'SingleHeader'
                                    )}
                                    <div className={classNames(uikit.flexColumn)}>
                                        <p className={defaultCss.appButtonTextSm}>
                                            <T textName='appButtonText' defaultStr='Загрузите в' page='/' />
                                        </p>
                                        <p>Google Play</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {
                        <div className={defaultCss.menuFooter}>
                            <p className={defaultCss.menuFooterText}>
                                <T
                                    textName='copyright'
                                    vars={{
                                        year: currentYear,
                                        company: project?.company
                                    }}
                                    defaultStr='Copyright © ${year} ${company}. All rights reserved'
                                    page='all'
                                />
                            </p>
                            <p className={defaultCss.menuFooterText}>
                                <T textName='devText' defaultStr='Разработка' page='all' />
                                {' — '}
                                <A className={defaultCss.cursorPointer} href={project?.developer?.link}>
                                    {project?.developer?.text}
                                </A>
                            </p>
                        </div>
                    } */}
                {/* </MobMenu> */}
                <header
                    className={classNames(
                        defaultCss.fullWidth,
                        defaultCss.headerSticky,
                        defaultCss.bgcWhite,
                        defaultCss.borderBtm,
                        { [defaultCss.headerStickyStore]: isStorePage && beforeHeaderRef?.current },
                        isStorePage ? 'store_fixed_search' : '',
                        compStyles?.headerStyles ? compStyles?.headerStyles : {}
                    )}
                    ref={headerRef}
                >
                    {/* <A
                        href={userToken ? '/events/73?i=0' : '#'}
                        onClick={
                            !userToken
                                ? (e) => {
                                      e.preventDefault();
                                      setState('showRegWindow', { type: 'login', redirect: '/events/73?i=0' });
                                  }
                                : undefined
                        }
                        className={defaultCss.topBanner}
                    >
                        <Img quality={100} className={defaultCss.topBannerImg} src={topBanner} />
                    </A> */}
                    {/* <A
                        href={userToken ? '/events/73?i=0' : '#'}
                        onClick={
                            !userToken
                                ? (e) => {
                                      e.preventDefault();
                                      setState('showRegWindow', { type: 'login', redirect: '/events/73?i=0' });
                                  }
                                : undefined
                        }
                        className={defaultCss.topBannerMob}
                    >
                        <Img quality={100} className={defaultCss.topBannerImg} src={topBannerMob} />
                    </A> */}
                    <div className={classNames(defaultCss.blockXl)}>
                        <div className={defaultCss.mainContainerWeb}>
                            <div className={defaultCss.mainHeader}>
                                <div className={defaultCss.mainMenuWrapper}>
                                    <nav
                                        className={classNames(
                                            defaultCss.dFlex,
                                            defaultCss.justifyContentBetween,
                                            defaultCss.fullWidth,
                                            defaultCss.aiCenter
                                        )}
                                    >
                                        <div
                                            className={classNames(defaultCss.mainMenuHamburgerNativeActive, {
                                                [defaultCss.mainMenuHamburgerSearch]: isInputOpened
                                            })}
                                            onClick={(event) => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                toggleMenu();
                                            }}
                                        >
                                            <div className={defaultCss.mainMenuHamburgerInner}>
                                                {svgSprite('burger', {
                                                    width: '1.5rem',
                                                    height: '1.5rem',
                                                    fill: 'var(--darkColor)'
                                                })}
                                            </div>
                                            <div
                                                style={{ cursor: 'pointer' }}
                                                className={classNames(defaultCss.mainMenuLogo)}
                                                onClick={(event) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    navigateV2('/');
                                                }}
                                            >
                                                <A href={`/`} className={defaultCss.mainMenuLogoLink}>
                                                    <Img quality={100} className={defaultCss.mainMenuLogoImg} src={headLogo} />
                                                </A>
                                            </div>
                                        </div>
                                        <div style={{ flexDirection: 'row' }} className={classNames(defaultCss.webMenuBlock)}>
                                            <SingleMenu componentCss={defaultCss} isMobile={isMobile} />
                                        </div>
                                        <HeaderButtons
                                            isInputOpened={isInputOpened}
                                            setIsInputOpened={setIsInputOpened}
                                            isStorePage={isStorePage}
                                            logout={logout}
                                        />
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={defaultCss.notificationsQuickWrapper}>
                        {quickNotifications.map((el) => (
                            <NotificationsQuick key={el?.id} notification={el} />
                        ))}
                    </div>
                </header>
            </div>
        </>
    );
};

export default SingleHeader;
